import React from 'react';
import PropTypes from 'prop-types';

import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material';

import classes from './iconStyles.module.css';

const OnInfoIcon = ({ content = '' }) => {
    return (
        <Tooltip title={content} placement={'top'}>
            <div className={classes.infoIcon}>
                <InfoIcon />
            </div>
        </Tooltip>
    );
};

OnInfoIcon.propTypes = {
    content: PropTypes.string
};

export default OnInfoIcon;
